/**
 * uiTokens.js
 *
 * The one place the system's surface palette is decided, so every frame,
 * sidebar and page reads from the same source instead of each keeping its own
 * copy. `colors` is the output of tokens(theme.palette.mode).
 *
 * NOTE: TopBar and the task manager's taskShared.js each still build this
 * inline. They are identical to what is here and worth folding in, but they
 * work, so they are left alone rather than touched in passing.
 */

import { alpha } from "@mui/material";

export const buildUi = (colors, isDark) => {
  const accent = colors.teal[500];
  const accent2 = colors.newTeal[500];

  return {
    accent,
    accent2,
    pageBg: isDark ? colors.dark[800] : "#e9ebef",
    surface: isDark ? colors.dark[700] : colors.white[900],
    surfaceAlt: isDark ? colors.dark[600] : colors.white[600],
    border: isDark
      ? alpha(colors.white[500], 0.09)
      : alpha(colors.dark[500], 0.1),
    textPrimary: colors.primary[100],
    textSecondary: isDark ? colors.gray[400] : colors.gray[300],
    gradient: `linear-gradient(135deg, ${accent} 0%, ${accent2} 100%)`,
    shadow: isDark
      ? "0 14px 34px -22px rgba(0,0,0,0.8)"
      : "0 14px 34px -24px rgba(16,24,74,0.35)",
  };
};

export default buildUi;
